import { type Common } from './common.js';

///////////////////////////////////////////////////
////// TYPES

export interface Geometry {
  longitude: string;
  latitude: string;
}

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async getStaticMapUrl(geometry: Geometry): Promise<string> {
    const url = this.common.constructPath('/patient-previsit/maps/static', {
      geometry,
    });

    const { staticMapUrl } = await this.common.getJSON(url);

    return staticMapUrl;
  }

  getStaticMapProxyUrl(geometry: Geometry): string | undefined {
    if (!geometry.latitude || !geometry.longitude) {
      return undefined;
    }

    const url = this.common.constructPath('/patient-previsit/maps/static-proxy', {
      geometry,
    });
    return url;
  }
}
